// import jsPDF from "jspdf";
// import QRCode from "qrcode";
// import nnLogo from "../assets/images/nnfitwatermark.png";
// import { ref, getBlob } from "firebase/storage";
// import { storage } from "../firebase/config";

// export const generateMemberCard = async (member, gym) => {
//   if (member?.photoBase64) {
//     try {
//       const imageType = member.photoBase64.startsWith("data:image/png")
//         ? "PNG"
//         : "JPEG";

//       doc.addImage(member.photoBase64, imageType, 60, 14, 18, 18);
//     } catch (error) {
//       console.error("Member photo error:", error);
//     }
//   }

//   const loadImage = (src) => {
//     return new Promise((resolve, reject) => {
//       const img = new Image();
//       img.crossOrigin = "Anonymous";

//       img.onload = () => resolve(img);
//       img.onerror = reject;

//       img.src = src;
//     });
//   };

//   const loadMemberImage = async (photoPath) => {
//     const storageRef = ref(storage, photoPath);

//     const blob = await getBlob(storageRef);

//     return await new Promise((resolve) => {
//       const reader = new FileReader();

//       reader.onloadend = () => resolve(reader.result);

//       reader.readAsDataURL(blob);
//     });
//   };
//   const doc = new jsPDF({
//     orientation: "landscape",
//     unit: "mm",
//     format: [85, 54], // ID Card Size
//   });

//   // Card Background
//   doc.setFillColor(255, 255, 255);
//   doc.roundedRect(2, 2, 81, 50, 3, 3, "F");

//   // Border
//   doc.setDrawColor(79, 70, 229);
//   doc.setLineWidth(0.8);
//   doc.roundedRect(2, 2, 81, 50, 3, 3);

//   // Header
//   doc.setFillColor(79, 70, 229);
//   doc.roundedRect(2, 2, 81, 10, 3, 3, "F");

//   // Gym Logo
//   // if (gym?.logo) {
//   //   try {
//   //     doc.addImage(gym.logo, "JPEG", 4, 3, 8, 8);
//   //   } catch (error) {
//   //     console.log(error);
//   //   }
//   // }

//   if (gym?.logo) {
//     try {
//       const gymLogo = await loadImage(gym.logo);

//       doc.addImage(gymLogo, "JPEG", 4, 3, 8, 8);
//     } catch (error) {
//       console.error("Gym logo error:", error);
//     }
//   }

//   // Gym Name
//   doc.setTextColor(255, 255, 255);
//   doc.setFontSize(11);
//   doc.setFont("helvetica", "bold");

//   doc.text(gym?.gymName || "GYM SAAS", 15, 8);

//   // Watermark
//   try {
//     doc.addImage(nnLogo, "PNG", 25, 12, 30, 30);
//   } catch (error) {
//     console.log(error);
//   }

//   // Member Photo
//   // if (member?.photo) {
//   //   try {
//   //     doc.addImage(member.photo, "JPEG", 60, 14, 18, 18);
//   //   } catch (error) {
//   //     console.log(error);
//   //   }
//   // }

//   if (member?.photoPath) {
//     try {
//       const memberImg = await loadMemberImage(member.photoPath);

//       doc.addImage(memberImg, "JPEG", 60, 14, 18, 18);
//     } catch (error) {
//       console.error("Member photo error:", error);
//     }
//   }

//   // if (member?.photo) {
//   //   try {
//   //     // const memberImg = await loadImage(member.photo);

//   //     // doc.addImage(memberImg, "JPEG", 60, 14, 18, 18);
//   //     const memberImg = await loadMemberImage(member.photoPath);

//   //     doc.addImage(memberImg, "JPEG", 60, 14, 18, 18);
//   //   } catch (error) {
//   //     console.error("Member photo error:", error);
//   //   }
//   // }

//   // Member Details
//   doc.setTextColor(15, 23, 42);

//   doc.setFontSize(7);

//   doc.setFont("helvetica", "bold");
//   doc.text("MEMBER DETAILS", 5, 18);

//   doc.setFont("helvetica", "normal");

//   doc.text(`ID : GYM-${member.id}`, 5, 23);

//   doc.text(`Name : ${member.fullName}`, 5, 27);

//   doc.text(`Plan : ${member.membershipPlan}`, 5, 31);

//   doc.text(`Trainer : ${member.trainerName || "N/A"}`, 5, 35);

//   // Status Badge
//   if (member.status === "Active") {
//     doc.setFillColor(34, 197, 94);
//   } else {
//     doc.setFillColor(239, 68, 68);
//   }

//   doc.roundedRect(5, 38, 18, 5, 2, 2, "F");

//   doc.setTextColor(255, 255, 255);
//   doc.setFontSize(6);
//   doc.text(member.status.toUpperCase(), 7, 41.5);

//   // Expiry
//   doc.setTextColor(220, 38, 38);
//   doc.setFontSize(7);

//   doc.text(`Valid Till : ${member.expiryDate}`, 5, 47);

//   // QR Code
//   const qrData = JSON.stringify({
//     memberId: member.id,
//     name: member.fullName,
//     plan: member.membershipPlan,
//   });

//   const qrImage = await QRCode.toDataURL(qrData);

//   doc.addImage(qrImage, "PNG", 60, 34, 15, 15);

//   doc.setTextColor(100);
//   doc.setFontSize(5);

//   doc.text("Scan To Verify", 59, 51);

//   // Footer Branding
//   doc.setTextColor(120);

//   doc.setFontSize(5);

//   doc.text("Powered By NN FIT", 28, 51);

//   doc.save(`${member.fullName}-ID-Card.pdf`);
// };

import jsPDF from "jspdf";
import QRCode from "qrcode";
import nnLogo from "../assets/images/nnfitwatermark.png";
import { auth } from "../firebase/config";

export const generateMemberCard = async (member, gym) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [85, 54],
  });

  // =========================================================
  // CARD BACKGROUND
  // =========================================================

  doc.setFillColor(255, 255, 255);
  doc.roundedRect(2, 2, 81, 50, 3, 3, "F");

  // Border
  doc.setDrawColor(79, 70, 229);
  doc.setLineWidth(0.8);
  doc.roundedRect(2, 2, 81, 50, 3, 3);

  // =========================================================
  // HEADER
  // =========================================================

  doc.setFillColor(79, 70, 229);
  doc.roundedRect(2, 2, 81, 10, 3, 3, "F");

  // =========================================================
  // GYM LOGO
  // USE BASE64 INSTEAD OF FIREBASE STORAGE URL
  // =========================================================

  if (gym?.logoBase64) {
    try {
      let logoType = "PNG";

      if (gym.logoBase64.startsWith("data:image/jpeg")) {
        logoType = "JPEG";
      }

      if (gym.logoBase64.startsWith("data:image/jpg")) {
        logoType = "JPEG";
      }

      if (gym.logoBase64.startsWith("data:image/png")) {
        logoType = "PNG";
      }

      doc.addImage(gym.logoBase64, logoType, 4, 3, 8, 8);
    } catch (error) {
      console.error("Gym Logo Error:", error);
    }
  }

  // =========================================================
  // GYM NAME
  // =========================================================

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");

  doc.text(gym?.gymName || "GYM SAAS", 15, 8);

  // =========================================================
  // NN FIT WATERMARK
  // =========================================================

  try {
    doc.addImage(nnLogo, "PNG", 25, 12, 30, 30);
  } catch (error) {
    console.error("NN FIT Logo Error:", error);
  }

  // =========================================================
  // MEMBER PHOTO
  // =========================================================

  if (member?.photoBase64) {
    try {
      let imageType = "JPEG";

      if (member.photoBase64.startsWith("data:image/png")) {
        imageType = "PNG";
      }

      doc.addImage(member.photoBase64, imageType, 60, 14, 18, 18);
    } catch (error) {
      console.error("Member Photo Error:", error);
    }
  }

  // =========================================================
  // MEMBER DETAILS
  // =========================================================

  doc.setTextColor(15, 23, 42);
  doc.setFontSize(7);

  doc.setFont("helvetica", "bold");

  doc.text("MEMBER DETAILS", 5, 18);

  doc.setFont("helvetica", "normal");

  // IMPORTANT:
  // Use member.memberId, NOT member.id

  doc.text(`ID : ${member?.memberId || "-"}`, 5, 23);

  doc.text(`Name : ${member?.fullName || "-"}`, 5, 27);

  doc.text(`Plan : ${member?.membershipPlan || "-"}`, 5, 31);

  doc.text(`Trainer : ${member?.trainerName || "N/A"}`, 5, 35);

  // =========================================================
  // STATUS
  // =========================================================

  if (member?.status === "Active") {
    doc.setFillColor(34, 197, 94);
  } else {
    doc.setFillColor(239, 68, 68);
  }

  doc.roundedRect(5, 38, 18, 5, 2, 2, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(6);

  doc.text((member?.status || "Unknown").toUpperCase(), 7, 41.5);

  // =========================================================
  // EXPIRY DATE
  // =========================================================

  doc.setTextColor(220, 38, 38);
  doc.setFontSize(7);

  doc.text(`Valid Till : ${member?.expiryDate || "-"}`, 5, 47);

  // =========================================================
  // QR CODE
  // =========================================================

  // const qrData = JSON.stringify({
  //   memberId: member?.memberId,
  //   name: member?.fullName,
  //   plan: member?.membershipPlan,
  // });
  // const qrData = JSON.stringify({
  //   gymId: gym.id || gym.uid,
  //   memberId: member.memberId,
  // });

  const gymId = auth.currentUser?.uid;

  if (!gymId) {
    throw new Error("Gym owner is not authenticated.");
  }

  if (!member?.memberId) {
    throw new Error("Member ID is missing.");
  }

  const qrData = JSON.stringify({
    gymId,
    memberId: member.memberId,
    name: member.fullName,
    plan: member.membershipPlan,
  });

  console.log("GENERATED QR DATA:", qrData);

  try {
    const qrImage = await QRCode.toDataURL(qrData, {
      width: 300,
      margin: 1,
    });

    doc.addImage(qrImage, "PNG", 60, 34, 15, 15);

    doc.setTextColor(100);
    doc.setFontSize(5);

    doc.text("Scan To Verify", 59, 51);
  } catch (error) {
    console.error("QR Code Error:", error);
  }

  // =========================================================
  // FOOTER
  // =========================================================

  doc.setTextColor(120);
  doc.setFontSize(5);

  doc.text("Powered By NN FIT", 28, 51);

  // =========================================================
  // DOWNLOAD
  // =========================================================

  doc.save(`${member?.memberId || member?.fullName || "Member"}-ID-Card.pdf`);
};
